/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OrderStatus/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Carrier from './Carrier/index'
import Indicator from './Indicator/index'
import Line from './Line/index'
import OrderId from './OrderId/index'
import ProductName from './ProductName/index'
import React from 'react'
import Status from './Status/index'
import Time from './Time/index'
import TrackAction from './TrackAction/index'
import TrackingId from './TrackingId/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OrderStatus({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/Content/OrderStatus"
  
}) {
let orderStatusStatusValueData = fromData.useDataValue({ viewPath,
context: 'order_status',
path: 'status',
})
let constantData = 'treatment_form_submitted'
let aggregateData = fromAggregate.equals(orderStatusStatusValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="OrderStatus.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z1b0voF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-Z1b0voF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-Z1b0voF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z1b0voF': aggregateData ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Line
  viewPath={`${viewPath}/Line`}
/>
<div
  data-testid="OrderStatus.Horizontal"
  data-view-path={viewPath}
 style={{'--g-5-Z1b0voF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<Status
  viewPath={`${viewPath}/Status`}
/>
</div>
<ProductName
  viewPath={`${viewPath}/ProductName`}
/>
<Time
  viewPath={`${viewPath}/Time`}
/>
<OrderId
  viewPath={`${viewPath}/OrderId`}
/>
<div
  data-testid="OrderStatus.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TrackingId
  viewPath={`${viewPath}/TrackingId`}
/>
<Carrier
  viewPath={`${viewPath}/Carrier`}
/>
</div>
<TrackAction
  viewPath={`${viewPath}/TrackAction`}
/>
</div>
{children}
</React.Fragment>)
}